import './App.css';
import { Link } from 'react-router-dom';

function Privacy() {
  return (
    <div className="App">
      <nav>
        <Link to="/" className="logo" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <img src="/iconyomuya.png" alt="Yomiya" style={{ height: '24px', width: '24px', marginRight: '8px' }} />
          Yomiya
        </Link>
        <ul className="nav-links">
          <li><Link to="/#features">Features</Link></li>
          <li><Link to="/#use-cases">For You</Link></li>
          <li><Link to="/#testimonials">Stories</Link></li>
        </ul>
      </nav>

      <section style={{ maxWidth: '800px', margin: '0 auto', padding: '4rem 2rem' }}>
        <h1>Yomiya – Privacy Policy</h1>
        <p style={{ color: '#666', marginBottom: '2rem' }}>Effective Date: January 2025</p>
        
        <div style={{ lineHeight: '1.8', color: '#333' }}>
          <p>
            This Privacy Policy explains how Proksi Yazılım ve Tasarım Hizmetleri Bilgisayar İthalat İhracat Ticaret Limited Şirketi ("Proksi Yazılım," "we," "our," "us") collects, uses, and protects your information when you use the Yomiya text-to-speech web application and related services (the "Service").
          </p>
          
          <p>
            <strong>Our Core Privacy Commitment:</strong> We do not store, track, or share the text content you input into Yomiya. Your texts stay yours. Period.
          </p>

          <p>
            By using Yomiya, you agree to the practices described in this Policy. If you do not agree, please stop using the Service.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>1. Information We Collect</h2>
          
          <h3 style={{ marginTop: '1.5rem', marginBottom: '0.5rem', fontSize: '1.1rem' }}>Text Content (Not Stored)</h3>
          <p>
            When you use Yomiya to convert text to speech, your text content is processed in real-time to generate audio. <strong>We do not store, save, or retain your text content.</strong> Your text is processed temporarily only for the purpose of generating speech and is immediately discarded after processing.
          </p>

          <h3 style={{ marginTop: '1.5rem', marginBottom: '0.5rem', fontSize: '1.1rem' }}>Usage Information</h3>
          <p>We may collect minimal technical information to improve the Service:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem' }}>
            <li><strong>Device Information:</strong> Device type, browser type, operating system, and screen resolution</li>
            <li><strong>Usage Analytics:</strong> General usage patterns (e.g., which features are used most), app version, and performance metrics</li>
            <li><strong>Technical Data:</strong> IP address (anonymized), crash logs, and error reports to improve stability</li>
          </ul>

          <h3 style={{ marginTop: '1.5rem', marginBottom: '0.5rem', fontSize: '1.1rem' }}>Account Information (If Applicable)</h3>
          <p>
            If Yomiya offers account creation or premium features, we may collect:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem' }}>
            <li>Email address (if you create an account)</li>
            <li>Subscription status and payment information (processed securely through third-party payment processors)</li>
            <li>Preferences and settings you configure</li>
          </ul>

          <h3 style={{ marginTop: '1.5rem', marginBottom: '0.5rem', fontSize: '1.1rem' }}>Cookies and Tracking</h3>
          <p>
            We may use cookies and similar technologies for:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem' }}>
            <li>Remembering your preferences (e.g., voice selection, speed settings)</li>
            <li>Analytics to understand how the Service is used and improve performance</li>
            <li>Security and fraud prevention</li>
          </ul>
          <p>
            We do not use cookies to track your browsing activity outside of Yomiya or to build advertising profiles.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem' }}>
            <li>Provide and operate the Yomiya text-to-speech service</li>
            <li>Process your text input in real-time to generate speech (text is not stored)</li>
            <li>Improve the Service's performance, accuracy, and user experience</li>
            <li>Diagnose technical issues and fix bugs</li>
            <li>Ensure security and prevent fraud or abuse</li>
            <li>Comply with legal obligations</li>
          </ul>
          <p>
            <strong>We do not use your text content for any purpose other than generating speech in real-time.</strong>
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>3. Data Storage and Retention</h2>
          <p>
            <strong>Text Content:</strong> Your text input is not stored. It is processed temporarily and immediately discarded after speech generation.
          </p>
          <p>
            <strong>Usage Data:</strong> We retain minimal usage analytics and technical data for as long as necessary to improve the Service, typically up to 24 months, unless a longer retention period is required by law.
          </p>
          <p>
            <strong>Account Data:</strong> If you create an account, we retain your account information for as long as your account is active. You may request deletion of your account at any time by contacting us.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>4. How We Share Information</h2>
          <p>
            <strong>We do not sell your data.</strong> We do not share your text content because we do not store it.
          </p>
          <p>We may share minimal technical information only with:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem' }}>
            <li><strong>Service Providers:</strong> Third-party services that help us operate Yomiya (e.g., cloud hosting, analytics tools) under strict confidentiality agreements</li>
            <li><strong>Legal Authorities:</strong> If required by law, court order, or to protect our rights, users, or the public</li>
            <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction</li>
          </ul>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>5. Your Privacy Rights</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem' }}>
            <li><strong>Access:</strong> Request a copy of the personal information we hold about you</li>
            <li><strong>Correction:</strong> Request correction of inaccurate information</li>
            <li><strong>Deletion:</strong> Request deletion of your personal information</li>
            <li><strong>Objection:</strong> Object to certain processing activities</li>
            <li><strong>Data Portability:</strong> Request transfer of your data to another service</li>
            <li><strong>Withdraw Consent:</strong> Withdraw consent for data processing at any time</li>
          </ul>
          <p>
            To exercise your rights, contact us at <strong>support@proksiyazilim.com</strong>. We will respond within 30 days or as required by applicable law.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>6. Children's Privacy</h2>
          <p>
            Yomiya is designed to be accessible to users of all ages, including children. We do not knowingly collect personal information from children under 13 without parental consent. If we discover that we have collected information from a child under 13 without proper consent, we will delete it promptly.
          </p>
          <p>
            Parents or guardians who believe their child has provided personal information should contact us immediately.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>7. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your information, including:
          </p>
          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem' }}>
            <li>Encryption of data in transit</li>
            <li>Secure servers and access controls</li>
            <li>Regular security assessments</li>
            <li>Minimal data collection (we don't store what we don't need)</li>
          </ul>
          <p>
            However, no system is completely secure. While we strive to protect your information, we cannot guarantee absolute security.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>8. International Data Transfers</h2>
          <p>
            Your information may be processed and stored on servers located outside your country, including in the European Union and the United States. We implement appropriate safeguards (such as encryption and standard contractual clauses) to protect your information in accordance with this Privacy Policy and applicable data protection laws.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>9. Third-Party Services</h2>
          <p>
            Yomiya may integrate with third-party services (such as analytics tools, payment processors, or hosting providers). These services have their own privacy policies and practices. We encourage you to review their privacy policies. We are not responsible for the privacy practices of third-party services.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>10. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. The latest version will always be available at <strong>https://yomiya.proksiyazilim.com/privacy</strong>. We will notify you of material changes by posting the updated Policy and updating the "Effective Date" at the top of this page.
          </p>
          <p>
            Your continued use of Yomiya after changes are posted constitutes your acceptance of the updated Privacy Policy. If you do not agree to the changes, you must stop using the Service.
          </p>

          <h2 style={{ marginTop: '2rem', marginBottom: '1rem' }}>11. Contact Us</h2>
          <p>If you have questions, concerns, or requests regarding this Privacy Policy or your data, please contact us at:</p>
          <p>
            <strong>support@proksiyazilim.com</strong><br />
            Proksi Yazılım ve Tasarım Hizmetleri Bilgisayar İthalat İhracat Ticaret Limited Şirketi<br />
            Teknopark Ankara, Turkey
          </p>
          <p style={{ marginTop: '2rem', color: '#666', fontSize: '0.9rem' }}>
            © 2025 Proksi Yazılım. All rights reserved.
          </p>
        </div>

        <div style={{ marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid #eee' }}>
          <Link to="/" style={{ color: '#2ecc71', textDecoration: 'none' }}>← Back to Home</Link>
        </div>
      </section>

      <footer>
        <p>&copy; 2025 Yomiya. Made with care for real people.</p>
        <p
          style={{
            marginTop: '1rem',
            fontSize: '0.9rem',
          }}
        >
          <Link to="/privacy">Privacy</Link> •{' '}
          <Link to="/terms">Terms</Link> •{' '}
          <a href="https://yomiya.proksiyazilim.com">Contact</a> •{' '}
          <a href="https://yomiya.proksiyazilim.com">Blog</a>
        </p>
      </footer>
    </div>
  );
}

export default Privacy;
